export enum DialPadLocalStorageKey {
  DIAL_PAD_VARIANT = 'dialPadVariant',
}
